import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Descriptions, Tag, Timeline, Divider, Space, Button } from 'antd';

const { Title } = Typography;

const AgencyDetails = () => {
  const [loading, setLoading] = useState(false);
  const [agency, setAgency] = useState(null);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    // TODO: Replace with real API calls
    setLoading(true);
    const timer = setTimeout(() => {
      setAgency({
        id: 1,
        name: 'Acme Media',
        email: 'contact@acme.com',
        phone: '+1 (555) 123-4567',
        status: 'active',
        created_at: '2025-01-15',
        updated_at: '2025-08-01',
        users_count: 8,
        clients_count: 14,
        workspaces_count: 4,
      });
      setLogs([
        { ts: '2025-08-10 12:21', text: 'Workspace limit updated from 3 to 4', type: 'info' },
        { ts: '2025-08-07 09:02', text: 'Invoice #INV-2041 paid ($299)', type: 'success' },
        { ts: '2025-08-01 18:34', text: 'User john.doe promoted to Manager', type: 'info' },
        { ts: '2025-07-21 10:11', text: 'Campaign CAP-110 flagged for review', type: 'warning' },
      ]);
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Agencies' },
        { title: 'Agency Details & Activity Logs' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Agency Details & Activity Logs</Title>
        <Space>
          <Button type="primary">Edit Agency</Button>
          <Button>Impersonate</Button>
        </Space>
      </div>

      <Card loading={loading} title="Agency Profile" style={{ marginBottom: 16 }}>
        {agency && (
          <Descriptions column={2} bordered size="middle">
            <Descriptions.Item label="ID">{agency.id}</Descriptions.Item>
            <Descriptions.Item label="Name">{agency.name}</Descriptions.Item>
            <Descriptions.Item label="Email">{agency.email}</Descriptions.Item>
            <Descriptions.Item label="Phone">{agency.phone}</Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag color={agency.status === 'active' ? 'green' : 'orange'}>{agency.status}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Users">{agency.users_count}</Descriptions.Item>
            <Descriptions.Item label="Clients">{agency.clients_count}</Descriptions.Item>
            <Descriptions.Item label="Workspaces">{agency.workspaces_count}</Descriptions.Item>
            <Descriptions.Item label="Created">{agency.created_at}</Descriptions.Item>
            <Descriptions.Item label="Updated">{agency.updated_at}</Descriptions.Item>
          </Descriptions>
        )}
      </Card>

      <Card title="Activity Logs" loading={loading}>
        <Timeline
          items={logs.map(l => ({
            color: l.type === 'success' ? 'green' : l.type === 'warning' ? 'orange' : 'blue',
            children: (
              <div>
                <div style={{ fontWeight: 500 }}>{l.text}</div>
                <div style={{ color: '#888' }}>{l.ts}</div>
              </div>
            )
          }))}
        />
        <Divider />
        <div style={{ color: '#888' }}>This is a placeholder timeline. Connect to your backend logs endpoint for real data.</div>
      </Card>
    </div>
  );
};

export default AgencyDetails;
